import { Injectable } from '@angular/core';
import { GlobalProvider } from 'src/services/global';
import { Pages } from './interfaces/pages';

@Injectable({
  providedIn: 'root',
})
export class MenuHelper {
  map = [];
  public configPages: Array<Pages> = [];
  public adminPages: Array<Pages> = [];
  public employeePages: Array<Pages> = [];

  public generalPages: Array<Pages> = [];
  public essentialPages: Array<Pages> = [];
  constructor(private g: GlobalProvider) {
    this.map[`/customer-portal`] = `custPortal`;
    this.map[`/customer-account`] = `custAccount`;
    this.map[`/accessRole`] = `AccessRole`;
    this.map[`/adhoc-type`] = `AdhocType`;
  }
  loadMenu() {
    this.configPages = [];
    this.adminPages = [];
    this.employeePages = [];
    this.generalPages = [];
    this.essentialPages = [];

    this.addRoute(
      {
        title: 'Access Log',
        url: '/accessLog',
        direct: 'root',
        icon: 'flash',
      },
      this.configPages
    );
    this.addRoute(
      {
        title: 'Company Setting',
        url: '/companySetting',
        direct: 'root',
        icon: 'flash',
      },
      this.configPages
    );

    // Customer Portal
    this.addRoute(
      {
        title: 'Customer Portal',
        url: '/customer-portal',
        direct: 'root',
        icon: 'flash',
      },
      this.configPages
    );
    // Customer Account
    this.addRoute(
      {
        title: 'Customer Account',
        url: '/customer-account',
        direct: 'root',
        icon: 'flash',
      },
      this.configPages
    );
    // Access Role
    this.addRoute(
      {
        title: 'Access Role',
        url: '/accessRole',
        direct: 'root',
        icon: 'flash',
      },
      this.configPages
    );
    // Adhoc Type
    this.addRoute(
      {
        title: 'Adhoc Type',
        url: '/adhoc-type',
        direct: 'root',
        icon: 'flash',
      },
      this.configPages
    );
    // PH
    this.addRoute(
      {
        title: 'PH',
        url: '/ph',
        direct: 'root',
        icon: 'pin',
      },
      this.configPages
    );
    // Country
    this.addRoute(
      {
        title: 'Country',
        url: '/country',
        direct: 'root',
        icon: 'pin',
      },
      this.configPages
    );
    // Leave Type
    this.addRoute(
      {
        title: 'Leave Type',
        url: '/leaveType',
        direct: 'root',
        icon: 'document',
      },
      this.configPages
    );
    // Package
    this.addRoute(
      {
        title: 'Package',
        url: '/package',
        direct: 'root',
        icon: 'albums',
      },
      this.configPages
    );
    // Site
    this.addRoute(
      {
        title: 'Sites',
        url: '/sites',
        direct: 'root',
        icon: 'business',
      },
      this.configPages
    );
    // Site
    this.addRoute(
      {
        title: 'Project Setting',
        url: '/projectSetting',
        direct: 'root',
        icon: 'business',
      },
      this.configPages
    );
    // ADMIN PAGE
    // Dashboard
    this.addRoute(
      {
        title: 'Dashboard',
        url: '/dashboard',
        direct: 'root',
        icon: 'grid',
      },
      this.adminPages
    );
    // Employee
    this.addRoute(
      {
        title: 'Employee Details',
        url: '/employees',
        direct: 'root',
        icon: 'body',
      },
      this.adminPages
    );
    // Manual Entry
    this.addRoute(
      {
        title: 'Manual Entry',
        url: '/employees/manual-entries',
        direct: 'root',
        icon: 'reader',
      },
      this.adminPages
    );

    // Pass
    this.addRoute(
      {
        title: 'Passes',
        url: '/passes',
        direct: 'root',
        icon: 'reader',
      },
      this.adminPages
    );
    // Leave
    this.addRoute(
      {
        title: 'Leaves',
        url: '/leaves',
        direct: 'root',
        icon: 'reader',
      },
      this.adminPages
    );
    // Payroll
    this.addRoute(
      {
        title: 'Payroll',
        url: '/payroll',
        direct: 'root',
        icon: 'wallet',
      },
      this.adminPages
    );
    // Project
    this.addRoute(
      {
        title: 'Projects',
        url: '/projects',
        direct: 'root',
        icon: 'hammer',
      },
      this.adminPages
    );
    // Attendance
    this.addRoute(
      {
        title: 'Attendance',
        url: '/timesheet',
        direct: 'root',
        icon: 'time',
      },
      this.adminPages
    );

    this.addRoute(
      {
        title: 'OM Dashboard',
        url: '/om-dashboard',
        direct: 'root',
        icon: 'grid',
      },
      this.employeePages
    );
    this.addRoute(
      {
        title: 'Employee Dashboard',
        url: '/emp-dashboard',
        direct: 'root',
        icon: 'grid',
      },
      this.employeePages
    );
    this.addRoute(
      {
        title: 'My Inbox',
        url: '/emp-inbox',
        direct: 'root',
        icon: 'mail',
      },
      this.employeePages
    );
    this.addRoute(
      {
        title: 'My Leaves',
        url: '/emp-leaves',
        direct: 'root',
        icon: 'document',
      },
      this.employeePages
    );
    this.addRoute(
      {
        title: 'My Passes',
        url: '/emp-passes',
        direct: 'root',
        icon: 'reader',
      },
      this.employeePages
    );
    this.addRoute(
      {
        title: 'My Jobs',
        url: '/emp-projects',
        direct: 'root',
        icon: 'hammer',
      },
      this.employeePages
    );
    this.addRoute(
      {
        title: 'My Attendance',
        url: '/emp-timesheet',
        direct: 'root',
        icon: 'time',
      },
      this.employeePages
    );
    this.generalAccessCheck();
  }
  generalAccessCheck() {
    if (`ADMIN` === this.g.role || (this.g.accessRole && this.g.accessRole.all)) {
    } else {
      // const auditLog = this.g.accessRole.accessRoleRights.find(
      //   (r) => r.accessClassName === `AuditLog`
      // );
      // const docShare = this.g.accessRole.accessRoleRights.find(
      //   (r) => r.accessClassName === `DocShare`
      // );
    }
  }
  addRoute(obj, routes) {
    if (`ADMIN` === this.g.role || (this.g.accessRole && this.g.accessRole.all)) {
      routes.push(obj);
      return;
    }
    if (this.g.accessRole && this.map[obj.url]) {
      const className = this.map[obj.url];
      const found = this.g.accessRole.accessRoleRights.find(
        (r) => r.accessClassName === className && r.key === 'list'
      );
      if (found) routes.push(obj);
      return;
    }
  }
}
